function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import findLast from 'lodash/findLast';
import map from 'lodash/map';
import get from 'lodash/get';
import partition from 'lodash/partition';
import filter from 'lodash/filter';
import find from 'lodash/find';
import { formatDate, getNowAsUtc } from 'helpers/datetime';
import Avatar from 'components/Avatar';
import Tabs from 'components/Tabs';
import noteShape from 'shapes/noteShape';
import * as shapes from '../../shapes';
import messages from '../../messages';
import PrivateNoteInfo from '../../components/PrivateNoteInfo';
import VisitNoteHeader from '../../components/VisitNoteHeader';
import ReplyNote from '../../components/ReplyNote';
import styles from '../../components/VisitNotes.pcss';
var _React_PureComponent;
class VisitNotes extends (_React_PureComponent = React.PureComponent) {
    static getDerivedStateFromProps(props, state) {
        const { notes } = props;
        const { replyNote } = state;
        if (replyNote && notes.length) {
            const note = find(notes, (n)=>n.noteType === 'Note' && n.payload && n.payload.replyTo === replyNote.payload.replyTo);
            if (note) {
                return {
                    replyNote: null
                };
            }
        }
        return null;
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.replyingTo !== this.state.replyingTo && this.state.replyingTo && this.replyNoteRef.current) {
            this.replyNoteRef.current.focus();
        }
    }
    onCancel() {
        if (this.state.replyingTo) {
            this.setState({
                replyingTo: null,
                replyNote: null
            });
        }
    }
    onChange(replyContent) {
        this.setState((state)=>{
            const currentNote = findLast(this.props.notes, (n)=>n.noteType === 'Note' && n.payload && n.replyTo === state.replyingTo.noteId);
            const replyNote = {
                noteId: get(currentNote, 'noteId', 'replyNote'),
                noteType: 'Note',
                content: replyContent,
                timestamp: get(currentNote, 'timestamp', +getNowAsUtc().locale('en').format('X')),
                payload: {
                    replyTo: state.replyingTo.noteId,
                    byPwd: this.props.mode === 'PWD'
                }
            };
            return {
                replyNote
            };
        });
    }
    onChangeNotesVisibility(noteId) {
        const idx = this.state.openVisitNotes.indexOf(noteId);
        if (idx === -1) {
            this.setState((prevState)=>({
                    openVisitNotes: [
                        ...prevState.openVisitNotes,
                        noteId
                    ]
                }));
        } else {
            this.setState((prevState)=>({
                    openVisitNotes: prevState.openVisitNotes.filter((nid)=>nid !== noteId)
                }));
        }
    }
    onReply(note) {
        this.setState({
            replyingTo: note
        });
    }
    onReplyNoteFormDidMount(noteFormRef) {
        if (this.notesSectionRef && this.notesSectionRef.current) {
            const notesSection = this.notesSectionRef.current;
            const replyNote = noteFormRef.current;
            const notesSectionRect = notesSection.getBoundingClientRect();
            const replyNoteRect = replyNote.getBoundingClientRect();
            if (notesSection && replyNote) {
                const isBelow = replyNoteRect.bottom > notesSectionRect.bottom;
                if (isBelow) {
                    notesSection.scrollBy({
                        top: replyNoteRect.bottom - replyNoteRect.top,
                        behavior: 'smooth'
                    });
                }
            }
        }
    }
    onSubmit(replyContent) {
        if (!replyContent) {
            this.setState({
                replyingTo: null,
                replyNote: null
            });
            return;
        }
        const { phiSet, phiSetDocumentId } = this.props;
        const { phisetVisitId, metadata } = this.props.visit;
        const currentNote = findLast(this.props.notes, (n)=>n.noteType === 'Note' && n.payload && n.payload.replyTo === this.state.replyingTo.noteId);
        const updatedNote = _object_spread_props(_object_spread({}, currentNote), {
            noteType: 'Note',
            content: replyContent,
            payload: {
                replyTo: this.state.replyingTo.noteId,
                byPwd: this.props.mode === 'PWD',
                isPrivate: this.state.activeView === 'private'
            }
        });
        if (!updatedNote.timestamp) updatedNote.timestamp = +getNowAsUtc().locale('en').format('X');
        this.props.onStoreNotes([
            updatedNote
        ], phiSet, phiSetDocumentId, phisetVisitId, metadata);
        this.setState({
            replyingTo: null
        });
    }
    renderReplySection(note, replyNotes, isMainNote = false) {
        const isOpen = this.state.openVisitNotes.indexOf(note.noteId) !== -1;
        if (!isMainNote && !isOpen) {
            return null;
        }
        const replies = filter(replyNotes, (rn)=>rn.payload && rn.payload.replyTo === note.noteId);
        return /*#__PURE__*/ _jsx(motion.div, {
            initial: {
                height: 0
            },
            animate: {
                height: 'auto'
            },
            exit: {
                height: 0
            },
            transition: {
                ease: 'easeOut',
                duration: 0.15
            },
            style: {
                overflow: 'hidden'
            },
            className: styles.replySection,
            children: /*#__PURE__*/ _jsx(ReplyNote, {
                mode: this.props.mode,
                note: note,
                replyNotes: replyNotes,
                replyingTo: this.state.replyingTo,
                isLast: !replies.length,
                isReplyNoteFormWithActionButtons: true,
                pwdAvatar: this.props.pwdAvatar,
                hcpAvatar: this.props.hcpAvatar,
                onReplyNoteFormDidMount: (noteFormRef)=>this.onReplyNoteFormDidMount(noteFormRef),
                onCancel: ()=>this.onCancel(),
                onChange: (replyContent)=>this.onChange(replyContent),
                onReply: (n)=>this.onReply(n),
                onSubmit: (replyContent)=>this.onSubmit(replyContent)
            }, note.noteId)
        });
    }
    renderNote(note, replyNotes) {
        const isOpen = this.state.openVisitNotes.indexOf(note.noteId) !== -1;
        const { payload } = note;
        return /*#__PURE__*/ _jsxs("div", {
            className: [
                styles.note__container
            ],
            "data-testid": "note",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: cn('pseudoEditorWrapper', {
                        'mb-5': isOpen,
                        [styles.noteWithPayload]: payload,
                        [styles.noteWithDateRange]: payload && (payload.start || payload.end)
                    }),
                    children: /*#__PURE__*/ _jsx(VisitNoteHeader, {
                        note: note,
                        openVisitNotes: this.state.openVisitNotes,
                        onChangeNotesVisibility: (noteId)=>this.onChangeNotesVisibility(noteId)
                    })
                }),
                /*#__PURE__*/ _jsx(AnimatePresence, {
                    children: this.renderReplySection(note, replyNotes)
                })
            ]
        }, note.noteId);
    }
    renderMainNote(note, replyNotes) {
        if (!note) {
            return null;
        }
        return /*#__PURE__*/ _jsx("div", {
            className: styles.note__container,
            "data-testid": "main-note",
            children: this.renderReplySection(note, replyNotes, true)
        }, note.noteId);
    }
    renderNotes(primaryNotes, replyNotes) {
        if (!primaryNotes.length) {
            return null;
        }
        return /*#__PURE__*/ _jsx("div", {
            className: styles.notes,
            children: map(primaryNotes, (note)=>this.renderNote(note, replyNotes))
        });
    }
    renderNotesSection() {
        const notes = [
            ...this.props.notes
        ];
        const commentNote = findLast(notes, {
            noteType: 'Comment'
        });
        if (commentNote) notes.pop();
        if (this.state.activeView === 'private') {
            const [primaryNotes, replyNotes] = partition(notes, (note)=>note.noteType === 'Comment');
            return /*#__PURE__*/ _jsxs("div", {
                className: styles.notesSection,
                ref: this.notesSectionRef,
                "data-testid": "private-notes-section",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.notes,
                        children: [
                            /*#__PURE__*/ _jsx(PrivateNoteInfo, {}),
                            this.renderNotes(primaryNotes, commentNote)
                        ]
                    }),
                    commentNote && this.renderMainNote(commentNote, replyNotes)
                ]
            });
        }
        const recommendationNote = findLast(notes, {
            noteType: 'Recommendation'
        });
        if (recommendationNote) notes.pop();
        const { replyingTo, replyNote } = this.state;
        const [replyNotes, primaryNotes] = partition(notes, (note)=>note.noteType === 'Note');
        if (!replyingTo && replyNote) replyNotes.push(replyNote);
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.notesSection,
            ref: this.notesSectionRef,
            "data-testid": "shared-notes-section",
            children: [
                this.renderNotes(primaryNotes, replyNotes),
                recommendationNote && this.renderMainNote(recommendationNote, replyNotes)
            ]
        });
    }
    renderTabs() {
        if (this.props.mode === 'PWD') {
            return null;
        }
        return /*#__PURE__*/ _jsx(Tabs, {
            activeItem: this.state.activeView,
            items: [
                'shared',
                'private'
            ],
            messages: messages.tabs,
            action: (activeView)=>this.setState({
                    activeView
                })
        });
    }
    renderVisitInfo() {
        const { visit, isMobile } = this.props;
        const hcp = get(visit, 'metadata.createdBy', {});
        const visitDate = get(visit, 'metadata.visitDate');
        const { firstName, lastName, clinic, avatar } = hcp;
        if (isMobile) {
            const clinicInfo = clinic ? `${clinic.name}, ${clinic.city}` : '';
            return /*#__PURE__*/ _jsxs("div", {
                className: cn(styles.visitInfo, styles['visitInfo--mobile']),
                children: [
                    /*#__PURE__*/ _jsx(Avatar, {
                        avatarImg: avatar,
                        name: [
                            firstName,
                            lastName
                        ],
                        // imgClassName="sidebar__avatar"
                        className: styles.visitInfoAvatar
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "d-flex flex-column justify-content-between ml-3",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "text--large text--medium",
                                children: [
                                    firstName,
                                    " ",
                                    lastName
                                ]
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "text--base text--light",
                                children: clinicInfo
                            })
                        ]
                    })
                ]
            });
        }
        return /*#__PURE__*/ _jsxs("ul", {
            className: styles.visitInfo,
            children: [
                /*#__PURE__*/ _jsxs("li", {
                    className: "col-auto",
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            className: "caption d-block mb-2",
                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.hcp))
                        }),
                        /*#__PURE__*/ _jsxs("span", {
                            className: "d-block text--base",
                            children: [
                                firstName,
                                " ",
                                lastName
                            ]
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            className: "d-block text--base",
                            children: clinic === null || clinic === void 0 ? void 0 : clinic.name
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("li", {
                    className: "col-auto",
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            className: "caption d-block mb-2",
                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.date))
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            className: "d-block text--base",
                            children: formatDate(visitDate)
                        })
                    ]
                })
            ]
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                this.renderVisitInfo(),
                this.renderTabs(),
                this.renderNotesSection()
            ]
        });
    }
    constructor(props){
        super(props);
        this.replyNoteRef = /*#__PURE__*/ React.createRef();
        this.notesSectionRef = /*#__PURE__*/ React.createRef();
        this.state = {
            activeView: 'shared',
            replyingTo: null,
            replyNote: null,
            openVisitNotes: []
        };
    }
}
_define_property(VisitNotes, "propTypes", {
    // Explicit props
    visit: shapes.visit,
    notes: PropTypes.arrayOf(noteShape),
    mode: PropTypes.oneOf([
        'HCP',
        'PWD'
    ]).isRequired,
    phiSet: PropTypes.object,
    phiSetDocumentId: PropTypes.string,
    isMobile: PropTypes.bool,
    isReplyNoteFormWithActionButtons: PropTypes.bool,
    pwdAvatar: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
        avatar: PropTypes.string
    }),
    hcpAvatar: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
        avatar: PropTypes.string
    }),
    // Explicit action
    onStoreNotes: PropTypes.func.isRequired
});
export default withStyles(styles)(VisitNotes);
